import { helper as buildHelper } from '@ember/component/helper';
export function has([val, set]) {
  return set.has(val);
}
export default buildHelper(has);